/**
 * Writing a user's precise location to their account.
 *
 * This module used to also CAPTURE that location, straight after login. That is
 * gone: asking for precise coordinates on a screen with no location feature
 * can't be disclosed in context, and the disclosure has to come before the
 * collection and name both the data and every purpose. The only place that asks
 * for a fix now is the Nearby page, behind its own in-context disclosure — so
 * all that's left here is persisting a fix Nearby already holds.
 *
 * The SUPER_ADMIN "Users by location" map is unaffected: the backend still
 * stamps a coarse, IP-derived location onto `kyc.geoLocation` at every login.
 */
import { getApolloClient } from '@/lib/apollo';
import { UPDATE_GEO_LOCATION } from '@/graphql';

/**
 * Persist already-known coordinates (e.g. the fix the Nearby page already has)
 * to the signed-in user's KYC. Best-effort. Only call when the user is logged
 * in — the mutation requires auth and would otherwise just error.
 */
export function persistGeoLocation(geoLocation: string): void {
  if (!geoLocation) return;
  void getApolloClient()
    .mutate({ mutation: UPDATE_GEO_LOCATION, variables: { geoLocation } })
    .catch(() => {
      /* network/auth error — IP fallback already covers this */
    });
}
